import { Routes, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Branding from "./pages/Branding";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import OurTeam from "./pages/OurTeam";
import OnlineStore from "./pages/OnlineStore";
import EventPackages from "./pages/EventPackages";
import TeamBiography from "./pages/TeamBiography";
import TermsAndConditions from "./pages/TermsAndConditions";
import ScrollToTop from "./components/ScrollToTop";
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (

    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar />
      <Analytics />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/events" element={<Events />} />
        <Route path="/packages/:type" element={<EventPackages />} />
        <Route path="/online-store" element={<OnlineStore />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/team-biography" element={<TeamBiography />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
